import { Col, Row, UploadFile } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { useCompositorContext } from '../CompositorProvider';

import { FormFieldActionEvent, JAvatarProps } from './../../models';
import { UserAvatar } from './../AvatarPreview';
import { JUpload } from './JUpload';

export const JAvatar: FC<JAvatarProps> = (props) => {
    const { getURLFromFileRef } = useCompositorContext()
    const [avatarImageURL, setAvatarImageURL] = useState<string | null>(null)
    const [showAvatarPreview, setShowAvatarPreview] = useState<boolean>(!!props.showAvatarPreview)

    useEffect(() => {
        if (props.showAvatarPreview) {
            (async () => {
                const value = props.value?.[0]
                if (value) {
                    const fileurl = await getURLFromFileRef(value);
                    setAvatarImageURL(fileurl)
                }
            })()
        }
    }, [])

    const onChangeFile = (event: UploadFile[] | undefined) => {
        if (event && event[0]) {
            const url = URL.createObjectURL(event[0].originFileObj as any)
            setAvatarImageURL(url)
        } else {
            setAvatarImageURL(null)
        }
    }
    const onUploadAction = (event: FormFieldActionEvent) => {
        if (props.cropRenderMode === 'replace') {
            if (event.type === 'OPEN_CROP') {
                setShowAvatarPreview(false)
            }
            if (event.type === 'CLOSE_CROP') {
                setShowAvatarPreview(true)
            }
        }
        props.onAction(event)
    }
    return (
        <Row>
            {
                showAvatarPreview && (
                    <Col span={24}>
                        <UserAvatar imageURL={avatarImageURL} size={125} formFullname={props.fullname} showOverlayPanel />
                    </Col>

                )
            }
            <Col span={24}>
                <JUpload {...props} onAction={onUploadAction} onChange={onChangeFile} />
            </Col>
        </Row>
    )
}